import 'iframe-resizer/js/iframeResizer.contentWindow'
import 'url-search-params' // polyfill
import PosabitApp from './lib/app'
import PosabitWidget from './lib/widget'
  ;(function (document, window) {
  // Script args
  const params = new URLSearchParams(window.location.search)
  const config = params.get('config')

  function isIframe () {
    try {
      return window.self !== window.top
    } catch (e) {
      return true
    }
  }

  if (!config) {
    console.warn('No config options passed. Exiting.')
  } else if (!isIframe()) {
    console.warn('This url can only be accessed via iframe. Exiting.')
  } else {
    window.posabitmenuwidget = JSON.parse(config)
    window.posabitmenuwidget.config.iframe = false // reset to prevent loop
    window.posabitmenuwidget.config.element_id = 'app' // element id is always 'app' in iframe

    // Widget settings object
    const appConfig = window.posabitmenuwidget

    // Convenience methods
    const widget = new PosabitWidget(appConfig)
    const app = new PosabitApp(appConfig)

    // Ensure everything is configured and giddy up
    if (widget.isConfigured() && widget.hasTargetElement()) {
      app.authAndMount()
    }
  }
})(document, window)
